function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useFieldArray, useForm } from 'react-hook-form';
import { FetchResponseError } from "../../shared/JSONRequest";
import { Modal } from "../V2/Components/UI";
import { settingsAtom, translationsAtom, inlineEditAtom, notificationAtom } from "../V2/atoms";
import { InputField } from "../V2/Components/Forms";
import { Button } from "../V2/Components/UI/Button";

import { postV2 } from "../V2/api/translations";
import { t } from "./translateFunction";

const TranslateModal = () => {
  const [inlineEditState, setInlineEditState] = useAtom(inlineEditAtom);
  const [translations] = useAtom(translationsAtom);
  const setNotifications = useSetAtom(notificationAtom);
  const context = translations[0].contexts.find((ctx) => ctx.id === inlineEditState.context);
  const { languages = [] } = useAtomValue(settingsAtom);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    mode: 'onSubmit'
  });

  const { fields } = useFieldArray({ control, name: 'data' });

  React.useEffect(() => {
    const initialValues = translations.map((translation) => {
      const language = languages.find((lang) => lang.key === translation.locale);
      const languageContext = translation.contexts.find((c) => c.id === (context === null || context === void 0 ? void 0 : context.id));
      const value =
      (languageContext === null || languageContext === void 0 ? void 0 : languageContext.values[inlineEditState.translationKey]) || inlineEditState.translationKey;
      return {
        language: language.key,
        value,
        key: inlineEditState.translationKey
      };
    });
    reset({ data: initialValues });
  }, [context, inlineEditState.translationKey, languages, reset, translations]);

  const closeModal = () => {
    setInlineEditState({ inlineEdit: true, translationKey: '', context: '' });
  };

  const submit = async ({ data }) => {
    if (isDirty) {
      const response = await postV2(data, context);
      if (response === 200) {
        setNotifications({
          type: 'success',
          text: t('System', 'Translations saved', null, false)
        });
      }
      if (response instanceof FetchResponseError) {var _response$json;
        const message = (_response$json = response.json) !== null && _response$json !== void 0 && _response$json.prettyMessage ?
        response.json.prettyMessage :
        response.message;
        setNotifications({
          type: 'error',
          text: t('System', 'An error occurred', null, false),
          details: message
        });
      }
    }
    closeModal();
  };

  return (
    inlineEditState.context && /*#__PURE__*/
    _jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "z-[10000] relative" }, void 0, /*#__PURE__*/
    _jsx(Modal, { size: "xxxl", id: "translationsFormModal" }, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit) }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0,
    t('System', 'Translate', 'Translate', false), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: closeModal, disabled: isSubmitting }, void 0,
    t('System', 'Close', 'Close', false)
    )
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "flex flex-col gap-4" }, void 0,
    fields === null || fields === void 0 ? void 0 : fields.map((field, index) => /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/
      _jsx("span", { className: "font-normal text-gray-600" }, void 0,
      field.language.toUpperCase()
      ),

      id: field.id,
      key: field.id },
    register(`data.${index}.value`, { required: true }), {
      hasErrors: errors.data && errors.data[index] !== undefined,
      disabled: isSubmitting })
    )
    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closeModal,
      className: "grow",
      "data-testid": "cancel-button",
      disabled: isSubmitting }, void 0,

    t('System', 'Cancel', 'Cancel', false)
    ), /*#__PURE__*/
    _jsx(Button, {
      type: "submit",
      color: "primary",
      className: "grow",
      "data-testid": "save-button",
      disabled: isSubmitting }, void 0,

    t('System', 'Save', 'Save', false)
    )
    )
    )
    )
    )
    ));


};

export { TranslateModal };